import { Component, HostListener, Inject, Input, OnInit } from "@angular/core";
import { DIGITAL_MENU_CONSTANTS } from "@src/components/ib-MmB-gastronomic-proposal/constants/gastronomic-proposal-constants";
import { IMenu } from "@src/components/ib-MmB-gastronomic-proposal/models/digital-menu.model";
import { WINDOW_TOKEN } from "@src/ib-Mmb-app-tokens";

@Component({
    selector: 'ib-digital-menu-wine',
    templateUrl: './ib-digital-menu-wine.component.html',
    styleUrls: ['./ib-digital-menu-wine.component.scss']
})

export class IbDigitalMenuWineComponent implements OnInit {

    originPath = this.window.location.origin;
    isMobile: boolean = false;

    @Input() menu!: IMenu[];

    constructor(@Inject(WINDOW_TOKEN) private window: Window) { }

    ngOnInit(): void {
        this.setIsMobile();
    }

    onImgError(event: any): void {
        const winesRouteDefault = DIGITAL_MENU_CONSTANTS.DEFAULT_IMG + 'defaultWines.png';
        event.target.src = winesRouteDefault;
    }

    @HostListener('window:resize', ['$event'])
    onResize(event: Event) {
        this.setIsMobile();
    };

    private setIsMobile() {
        this.isMobile = this.window.innerWidth <= 480;
    }
}
